import { render, staticRenderFns } from "./login-wechat.vue?vue&type=template&id=37a10177"
import script from "./login-wechat.vue?vue&type=script&lang=js"
export * from "./login-wechat.vue?vue&type=script&lang=js"
import style0 from "./login-wechat.vue?vue&type=style&index=0&id=37a10177&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports